import React, { createContext, useContext, useState } from 'react';

const THEMES = {
  night: {
    id: 'night',
    name: 'Night',
    colors: ['#0f0f23', '#1a1a2e']
  },
  ocean: {
    id: 'ocean',
    name: 'Ocean',
    colors: ['#0a1628', '#0d2137']
  },
  rose: {
    id: 'rose',
    name: 'Rose',
    colors: ['#1a0f18', '#2e1a28']
  },
  lavender: {
    id: 'lavender',
    name: 'Lavender',
    colors: ['#150f23', '#251a35']
  }
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [themeId, setThemeId] = useState(() => {
    return localStorage.getItem('appTheme') || 'night';
  });

  const theme = THEMES[themeId] || THEMES.night;

  const setTheme = (id) => {
    if (THEMES[id]) {
      setThemeId(id);
      localStorage.setItem('appTheme', id);
    }
  };

  const bgStyle = {
    background: `linear-gradient(180deg, ${theme.colors[0]} 0%, ${theme.colors[1]} 100%)`,
    minHeight: '100vh'
  };

  return (
    <ThemeContext.Provider value={{ theme, themeId, themes: THEMES, setTheme, bgStyle }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within ThemeProvider');
  return context;
};

export { THEMES };
